export function siteHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    let lastScroll = 50;
    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        // 1. Add class when user scrolls down from top
        if (currentScroll > 50) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

        // 2 & 3. Detect scroll direction
        if (currentScroll > lastScroll) {
            // scrolling DOWN
            header.classList.add('scrolling-down');
            header.classList.remove('scrolling-up');
        } else {
            // scrolling UP
            header.classList.add('scrolling-up');
            header.classList.remove('scrolling-down');
        }

        lastScroll = currentScroll;
    });
}
